module.exports = __webpack_public_path__ + "media/images/client-22-eda3260b94204975534a53f872c3a06b.png";